export const formatNumber = (number) => {
  return new Intl.NumberFormat('id-ID', {
    style: 'decimal',
    minimumFractionDigits: 0,
    maximumFractionDigits: 2, // Allow up to 2 decimal places
  }).format(number);
};
